/*
 * @Author: zhouqm 13523524394@126.com
 * @Date: 2026-07-24 08:56:52
 * @LastEditors: zhouqm 13523524394@126.com
 * @LastEditTime: 2026-07-24 11:32:15
 * @FilePath: /xc/src/router/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { createRouter, createWebHashHistory } from "vue-router";
import { PAGES } from "@/cesium/pageLayers";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("@/views/HomeMap.vue"),
    meta: { pageId: "home", title: "总览" },
  },
  {
    path: "/supply",
    name: "supply",
    component: () => import("@/views/WaterSupply.vue"),
    meta: { pageId: "supply", title: "供水" },
  },
  {
    path: "/drainage",
    name: "drainage",
    component: () => import("@/views/Drainage.vue"),
    meta: { pageId: "drainage", title: "排水" },
  },
  {
    path: "/hydro",
    name: "hydro",
    component: () => import("@/views/HydroRain.vue"),
    meta: { pageId: "hydro", title: "水雨情" },
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

router.afterEach((to) => {
  const page = PAGES.find((p) => p.path === to.path);
  document.title = page
    ? `${page.name} · 智慧水利数字孪生`
    : "智慧水利数字孪生";
});

export default router;
